import { render } from "./TabCanais.vue?vue&type=template&id=5adbff17&scoped=true"
import script from "./TabCanais.vue?vue&type=script&lang=js"
export * from "./TabCanais.vue?vue&type=script&lang=js"

import "./TabCanais.vue?vue&type=style&index=0&id=5adbff17&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adbff17"]])

export default __exports__